// PGCET MCA Mock 5 — Computer Awareness (questions 31–55)
const pgcetmcaComputerAwareness = [
  {
    id: 31,
    question: "The inorder and preorder traversals of a binary tree are D B E A F C G and A B D E C F G respectively. Its postorder traversal is",
    options: [
      "A. D E B G F C A",
      "B. D B E F C G A",
      "C. D E B F G C A",
      "D. E D B F G C A"
    ],
    answer: "C"
  },
  {
    id: 32,
    question: "A full binary tree (every internal node has exactly two children) has 15 internal nodes. The number of its leaf nodes is",
    options: ["A. 16", "B. 15", "C. 30", "D. 31"],
    answer: "A"
  },
  {
    id: 33,
    question: "The maximum number of comparisons needed by binary search to search a sorted array of 1000 elements is",
    options: ["A. 500", "B. 1000", "C. 9", "D. 10"],
    answer: "D"
  },
  {
    id: 34,
    question: "Which of the following sorting algorithms is stable and has a worst-case time complexity of O(n log n)?",
    options: ["A. Quick sort", "B. Heap sort", "C. Merge sort", "D. Selection sort"],
    answer: "C"
  },
  {
    id: 35,
    question: "The time complexity of Dijkstra's single-source shortest path algorithm implemented with a binary min-heap, on a graph with V vertices and E edges, is",
    options: ["A. O(V²)", "B. O((V + E) log V)", "C. O(VE)", "D. O(V³)"],
    answer: "B"
  },
  {
    id: 36,
    question: `What is printed by the following C code?
      int x = 10, y = 3;
      printf("%d", x % y * y + x / y);`,
    options: ["A. 6", "B. 4", "C. 12", "D. 10"],
    answer: "A"
  },
  {
    id: 37,
    question: `What is printed by the following C code?
      char s[] = "PGCET";
      printf("%d", (int) sizeof(s));`,
    options: ["A. 5", "B. 6", "C. 8", "D. 4"],
    answer: "B"
  },
  {
    id: 38,
    question: `What is printed by the following C code?
      int a[] = {10, 20, 30, 40};
      int *p = a + 1;
      printf("%d", *p + *(p + 2));`,
    options: ["A. 50", "B. 30", "C. 70", "D. 60"],
    answer: "D"
  },
  {
    id: 39,
    question: "A column c of table T holds the values 1, NULL, 2, 2, NULL. What does SELECT COUNT(DISTINCT c) FROM T; return?",
    options: ["A. 2", "B. 3", "C. 5", "D. 4"],
    answer: "A"
  },
  {
    id: 40,
    question: "Relation R(A, B, C, D, E) has the functional dependencies A → B, BC → D and E → C. The candidate key of R is",
    options: ["A. AC", "B. AB", "C. AE", "D. BE"],
    answer: "C"
  },
  {
    id: 41,
    question: "Which ACID property guarantees that once a transaction has committed, its changes survive any subsequent system failure?",
    options: ["A. Atomicity", "B. Consistency", "C. Isolation", "D. Durability"],
    answer: "D"
  },
  {
    id: 42,
    question: "The subnet mask corresponding to the prefix /20 is",
    options: ["A. 255.255.255.240", "B. 255.255.240.0", "C. 255.255.248.0", "D. 255.240.0.0"],
    answer: "B"
  },
  {
    id: 43,
    question: "The correct sequence of segments exchanged in TCP's three-way handshake for connection establishment is",
    options: ["A. SYN, SYN-ACK, ACK", "B. SYN, ACK, FIN", "C. ACK, SYN, SYN-ACK", "D. SYN, SYN, ACK"],
    answer: "A"
  },
  {
    id: 44,
    question: "Using Hamming code, the minimum number of parity bits required to send 7 data bits with single-bit error correction is",
    options: ["A. 2", "B. 3", "C. 4", "D. 5"],
    answer: "C"
  },
  {
    id: 45,
    question: "The binary number (110.011)₂ in decimal is",
    options: ["A. 6.75", "B. 6.375", "C. 6.3", "D. 5.375"],
    answer: "B"
  },
  {
    id: 46,
    question: "The Gray code equivalent of the binary number 1101 is",
    options: ["A. 1001", "B. 1110", "C. 0111", "D. 1011"],
    answer: "D"
  },
  {
    id: 47,
    question: "The minimised form of the Boolean function F(A, B, C) = Σm(0, 2, 4, 6) is",
    options: ["A. C′", "B. A′", "C. B′C′", "D. A′C′ + B"],
    answer: "A"
  },
  {
    id: 48,
    question: "Processes P1, P2 and P3 all arrive at time 0 (in that order) with CPU bursts 5, 3 and 1 respectively. Using Round Robin scheduling with a time quantum of 2, the average waiting time is",
    options: ["A. 5.00", "B. 3.67", "C. 4.33", "D. 4.67"],
    answer: "C"
  },
  {
    id: 49,
    question: "The Banker's algorithm is used for",
    options: ["A. Deadlock prevention", "B. Deadlock avoidance", "C. Deadlock detection", "D. Deadlock recovery"],
    answer: "B"
  },
  {
    id: 50,
    question: "The disk head is at cylinder 50. Using FCFS disk scheduling, the total head movement for the request queue 82, 170, 43, 140, 24, 16, 190 is",
    options: ["A. 632 cylinders", "B. 208 cylinders", "C. 652 cylinders", "D. 642 cylinders"],
    answer: "D"
  },
  {
    id: 51,
    question: "A paging system has a TLB access time of 20 ns, a main memory access time of 100 ns and a TLB hit ratio of 80%. Ignoring page faults, the effective memory access time is",
    options: ["A. 120 ns", "B. 128 ns", "C. 140 ns", "D. 160 ns"],
    answer: "C"
  },
  {
    id: 52,
    question: "A non-pipelined processor takes 5 cycles per instruction. A 5-stage pipeline (1 cycle per stage, no stalls) executes 100 instructions. The speedup obtained is approximately",
    options: ["A. 5.00", "B. 4.81", "C. 4.50", "D. 1.04"],
    answer: "B"
  },
  {
    id: 53,
    question: `What is printed by the following Java code?
      String s1 = "abc";
      String s2 = new String("abc");
      System.out.print((s1 == s2) + " " + s1.equals(s2));`,
    options: ["A. false true", "B. true true", "C. true false", "D. false false"],
    answer: "A"
  },
  {
    id: 54,
    question: "Defining several functions with the same name but different parameter lists in the same scope is called",
    options: ["A. Function overriding", "B. Encapsulation", "C. Inheritance", "D. Function overloading"],
    answer: "D"
  },
  {
    id: 55,
    question: "Which level of software testing focuses on detecting defects in the interfaces and interactions between modules?",
    options: ["A. Unit testing", "B. Integration testing", "C. Acceptance testing", "D. Regression testing"],
    answer: "B"
  }
];

export default pgcetmcaComputerAwareness;
